module.exports = __webpack_public_path__ + "media/images/app/og-image-1c279d2c932833737f4bd2ec12c8e572.jpg";